const PERMISSION_KEY= "console:service_schema";
const PAGE_URL = {
    SERVICE_SCHEMA_PAGE: "/admin/console/service-schema"
}

export {PERMISSION_KEY, PAGE_URL}

